// export const url = "https://xtratoys.nextechltd.in/api";
// export const url = "https://adscpos.nextechltd.in/api";

// export const url = "http://103.241.144.228:8000/api";
// export const url = "https://everydaypos.nextechltd.in/api";
// export const isAdmin = false;

// export const adminUrl = "https://everydaycpos.nextechltd.in/api";
// export const adminUrl = "https://everydaycpos.nextechltd.in/api";

//export const url = "https://everydaypos.nextechltd.in/api";
export const url = "https://adscpos.nextechltd.in/api";
export const isAdmin = true;

export const adminUrl = "https://adscpos.nextechltd.in/api";

// export const isAdmin = false;

// export const adminUrl = "https://arihant.nextechltd.in/api";
// const hostname = window.location.hostname; // Will be the IP address or domain of the server
// const port = 8001; // Port where your Express backend is running
// console.log(hostname)
// export const url = `http://${hostname}:${port}/api`;
